import { Button, Table, Tabs } from "antd";
import Location from "./Location";
import FetchEmployeesService from "./FetchEmployeesService";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { formatDateToISO, formatShortDateLabel } from "./Utilitiy";
import FetchUnavailabilities from "./FetchUnavailabilities";
import AddBookedItemRoster from "./AddBookedItemRoster";
import DeleteBookedItemRoster from "./DeleteBookedItemRoster";
import AddBookedItemListRoster from "./AddBookedItemListRoster";
import TimePicker from "./TimePicker";
import ManagerOpenItemDialog from "./ManagerOpenItemDialog";
import OpenShiftClaimDialog from "./OpenShiftClaimDialog";
import ShiftActionModal from "./ShiftActionModal";
import RosterTemplateModal from "./RosterTemplateModal";
import AddBreaksForBookedItem from "./AddBreaksForBookedItem";
import AddAllowancesForBookedItem from "./AddAllowancesForBookedItem";
import AddUnavailability from "./AddUnavailability";
import UnavailabilityModal from "./UnavailabilityModal";
import FetchRosterAllocationService from "./FetchRosterAllocationService";
import './Roster.css'; // optional: for external CSS
const Roster = (props) => {
    const WIDTH = 1000;
    const HEIGHT = 800;

    const { bookedItems, setBookedItems, selectedLocation, companyAndLocations,showModal,setShowModal } = props;


    const previousDayIndexRef = useRef(null);

    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedCell, setSelectedCell] = useState(null);
    const [starttime, setStarttime] = useState(new Date());
    const [endtime, setEndtime] = useState(new Date());
    const [showTimePicker, setShowTimePicker] = useState(false);
    const [isStartTime, setIsStartTime] = useState(true); // Determines whether it's the start or end time being selected
    const [resources, setResources] = useState([]);
    //const [bookedItems, setBookedItems] = useState(props.bookedItem?props.bookedItem:[]);
    const [selectedBookedItem, setSelectedBookedItem] = useState(null); // State to store the selected booked item

    const listRef = useRef();
    const scheduleDateRef = useRef();
    const [loading, setLoading] = useState(false);
    const [listSize, setListSize] = useState(null); // This is `listSize`
    const [cellHeight, setCellHeight] = useState(null);

    const [combinedList, setCombinedList] = useState([]);
    const [bookedItemsVersion, setBookedItemsVersion] = useState(0);
    const chatWith = { id: 999999, firstName: 'AI Assist', email: 'ai@effiez.com.au', lastName: 'Musk', profileImageUrl: 'https://example.com/ai.jpg', unreadCount: 0, lastMessage: 'Hello there!' };

    const [showIndiviualShiftManagerWindow, setShowIndiviualShiftManagerWindow] = useState(false);
    const [showOpenItemModal, setShowOpenItemModal] = useState(false);
    const [showOpenItemModalManager, setShowOpenItemModalManager] = useState(false);
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [showUnavailabilityModal, setShowUnavailabilityModal] = useState(false);
    const VERTICAL_CELL_COUNT = 7; // one week

    const [dates, setDates] = useState([]);
    const [pageDates, setPageDates] = useState([]);
    const [currentWeekIndex, setCurrentWeekIndex] = useState(0);
    const [extendDirection, setExtendDirection] = useState(null);
    const [isExtending, setIsExtending] = useState(false);
    const [selectedOpenItem, setSelectedOpenItem] = useState(null);
    const [openItem,setOpenItem] = useState(null);
    const currentUserId = props.additionalUserInfo?.id;
    // Generate dates around today, aligned to Sunday
    const generateDatesAroundToday = (daysBefore = 56, daysAfter = 13) => {
        const today = new Date();

        // Align to start of week (Sunday)
        const weekStart = new Date(today);
        const dayOfWeek = weekStart.getDay();
        weekStart.setDate(weekStart.getDate() - dayOfWeek);

        const startDate = new Date(weekStart);
        startDate.setDate(startDate.getDate() - daysBefore);

        const totalDays = daysBefore + daysAfter;
        const dates = [];

        for (let i = 0; i <= totalDays; i++) {
            const d = new Date(startDate);
            d.setDate(startDate.getDate() + i);
            dates.push(d.toISOString().split('T')[0]);
        }

        return dates;
    };

    function formatToDDMMYYYY(isoDateStr) {
        const [year, month, day] = isoDateStr.split("-");
        return `${day}-${month}-${year}`;
    }

    const generatePageDates = (allDates) => {
        const pages = [];
        for (let i = 0; i < allDates.length; i += VERTICAL_CELL_COUNT) {
            pages.push(allDates.slice(i, i + VERTICAL_CELL_COUNT));
        }
        return pages;
    };

    const extendDates = (direction) => {
        if (isExtending) return; // prevent concurrent extends
        setIsExtending(true);

        const currentStart = new Date(dates[0]);
        const currentEnd = new Date(dates[dates.length - 1]);
        let newDates = [];

        if (direction === 'prev') {
            const newStart = new Date(currentStart);
            newStart.setDate(newStart.getDate() - VERTICAL_CELL_COUNT);

            for (let i = 0; i < VERTICAL_CELL_COUNT; i++) {
                const d = new Date(newStart);
                d.setDate(newStart.getDate() + i);
                const iso = d.toISOString().split('T')[0];
                if (!dates.includes(iso)) newDates.push(iso);
            }

            if (newDates.length === 0) {
                setIsExtending(false);
                return;
            }

            const updated = [...newDates, ...dates];
            setDates(updated);
            setExtendDirection('prev');
        }

        if (direction === 'next') {
            const newStart = new Date(currentEnd);
            newStart.setDate(newStart.getDate() + 1);

            for (let i = 0; i < VERTICAL_CELL_COUNT; i++) {
                const d = new Date(newStart);
                d.setDate(newStart.getDate() + i);
                const iso = d.toISOString().split('T')[0];
                if (!dates.includes(iso)) newDates.push(iso);
            }

            if (newDates.length === 0) {
                setIsExtending(false);
                return;
            }

            const updated = [...dates, ...newDates];
            setDates(updated);
            setExtendDirection('next');
        }
    };

    const goToNextWeek = () => {
        if (currentWeekIndex === pageDates.length - 1) {
            extendDates('next');
        } else {
            setCurrentWeekIndex(prev => prev + 1);
        }
    };

    const goToPrevWeek = () => {
        if (currentWeekIndex === 0) {
            extendDates('prev');
        } else {
            setCurrentWeekIndex(prev => prev - 1);
        }
    };

    // Initialize dates and pages around today
    useEffect(() => {
        const initialDates = generateDatesAroundToday(112, 13);
        setDates(initialDates);
        const pages = generatePageDates(initialDates);
        setPageDates(pages);

        const todayStr = new Date().toISOString().split('T')[0];
        const initialWeekIndex = pages.findIndex(week => week.includes(todayStr));
        setCurrentWeekIndex(initialWeekIndex !== -1 ? initialWeekIndex : 0);
    }, []);

    // After pageDates update due to extendDates, adjust currentWeekIndex properly
    useEffect(() => {
        if (!extendDirection || pageDates.length === 0) return;

        if (extendDirection === 'prev') {
            // Because we prepended one week, shift index forward by 1 to keep current view
            setCurrentWeekIndex(prev => prev + 1);
        } else if (extendDirection === 'next') {
            // No index change needed if appended at end
            // Optionally set to last page if you want to auto-scroll forward:
            // setCurrentWeekIndex(pageDates.length - 1);
        }

        setExtendDirection(null);
        setIsExtending(false);
    }, [pageDates, extendDirection]);

    const displayedResources = useMemo(() => {
        if (props.type !== 'my') {
            return resources;
        }

        const filteredResources = resources.filter((resource) => {
            return String(resource.id) === String(currentUserId) || String(resource.id) === '999999';
        });

        const hasCurrentUser = filteredResources.some((resource) => String(resource.id) === String(currentUserId));
        if (!hasCurrentUser && currentUserId) {
            filteredResources.unshift({
                id: currentUserId,
                firstName: props.additionalUserInfo?.firstName || 'My',
                lastName: props.additionalUserInfo?.lastName || 'Shift',
            });
        }

        return filteredResources;
    }, [currentUserId, props.additionalUserInfo?.firstName, props.additionalUserInfo?.lastName, props.type, resources]);

    const currentWeekRange = useMemo(() => {
        const currentWeek = pageDates[currentWeekIndex] || [];
        return {
            startDate: currentWeek[0] || '',
            endDate: currentWeek[currentWeek.length - 1] || '',
        };
    }, [currentWeekIndex, pageDates]);

    const selectedCompany = useMemo(() => {
        return companyAndLocations.find((company) => company.id === selectedLocation?.companyId) || companyAndLocations[0] || null;
    }, [companyAndLocations, selectedLocation?.companyId]);

    // Your combined list generation effect stays the same, no changes needed
    useEffect(() => {
        if (
            pageDates.length === 0 ||
            displayedResources.length === 0 
            
        ) return;

        const selectedWeekDates = pageDates[currentWeekIndex] || [];

        const combine = selectedWeekDates.map(dateISO => {
            const formattedDate = formatToDDMMYYYY(dateISO);
            const itemsForDate = bookedItems.filter(
                item => item.date === formattedDate
            );
          //  console.log('items for date', formattedDate, itemsForDate);
            const itemsByResourceByDate = displayedResources.reduce((acc, resource) => {
                const bookedItemsByResource = itemsForDate.filter(item =>
                    item.staffId === resource.id ||
                    (resource.firstName === 'Open' && ((item.status && item.status === 'available') || !item.staffId))
                );

                if (resource.firstName === 'Open' && bookedItemsByResource.length > 0) {
                    console.log('Open booked', bookedItemsByResource);
                    console.log('res', resource.id);
                }

                const key = resource.id ? resource.id : '999999';
                acc[key] = bookedItemsByResource;
                return acc;
            }, {});

            return {
                date: dateISO,
                ...itemsByResourceByDate,
                key: generateUUID()
            };
        });
        console.log('combine', combine);
        setCombinedList(combine);
    }, [pageDates, currentWeekIndex, bookedItems, displayedResources]);

    // Sync pages whenever dates change (this will also update pageDates on extend)
    useEffect(() => {
        if (dates.length === 0) return;

        const updatedPages = generatePageDates(dates);
        setPageDates(updatedPages);
    }, [dates]);

    // Your scroll and loading effect stays the same


    // Generate dates for past 15 days, today, and next 365 days


    function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    const groupBookedItemsByDate = (bookedItems) => {
        return bookedItems.reduce((grouped, item) => {
            const { date } = item; // Extract the date property
            if (!grouped[date]) {
                grouped[date] = []; // Initialize an array for this date if it doesn't exist
            }
            grouped[date].push(item); // Add the item to the corresponding date group
            return grouped;
        }, {}); // Start with an empty object
    };


    const getPreviousWeekBookedItems = (bookedItems) => {
        // Get today's date
        const currentDayIndex = pageDates[currentWeekIndex][0] ? dates.findIndex(date => date === pageDates[currentWeekIndex][0]) : 0;
        const targetDay = new Date(dates[currentDayIndex]);
       
        // Calculate the start of this week (assuming the week starts on Sunday)
        const startOfThisWeek = new Date(targetDay);
        
        // Calculate the start of the previous week
        const startOfPreviousWeek = new Date(startOfThisWeek);
        startOfPreviousWeek.setDate(startOfThisWeek.getDate() - 7);
        
        // Create an array of the seven days of the previous week
        const previousWeekDates = [];
        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfPreviousWeek);
            day.setDate(startOfPreviousWeek.getDate() + i);
            previousWeekDates.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0])); // Format as YYYY-MM-DD
        }

        // Group booked items by date
        const groupedBookedItems = groupBookedItemsByDate(bookedItems);

        // Create a grouped object for the previous week
        const previousWeekGroupedItems = {};
        previousWeekDates.forEach((date) => {
            previousWeekGroupedItems[date] = groupedBookedItems[date] || []; // Use an empty array if no items exist for the date
        });

        return previousWeekGroupedItems;
    };



    const mapPreviousWeekToCurrentWeek = (previousWeekGroupedItems) => {
       // Get today's date
        const currentDayIndex = pageDates[currentWeekIndex][0] ? dates.findIndex(date => date === pageDates[currentWeekIndex][0]) : 0;
        const targetDay = new Date(dates[currentDayIndex]);
       
        // Calculate the start of this week (assuming the week starts on Sunday)
        const startOfThisWeek = new Date(targetDay);
        
        // Calculate the start of the previous week
        const startOfPreviousWeek = new Date(startOfThisWeek);
        startOfPreviousWeek.setDate(startOfThisWeek.getDate() - 7);
        
        // Create an array of the seven days of the previous week
        const previousWeekDates = [];
        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfPreviousWeek);
            day.setDate(startOfPreviousWeek.getDate() + i);
            previousWeekDates.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0])); // Format as YYYY-MM-DD
        }

        // Create an array of the seven days of the current week
        const currentWeekDates = [];
        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfThisWeek);
            day.setDate(startOfThisWeek.getDate() + i);
            currentWeekDates.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0])); // Format as YYYY-MM-DD
        }

        // Map previous week's days to current week's days
        const currentWeekGroupedItems = {};
        previousWeekDates.forEach((prevDate, index) => {
            const currentDate = currentWeekDates[index];
            const prevGroupedItems = previousWeekGroupedItems[prevDate];
            const newGroupedItems = [];
            prevGroupedItems.forEach((item) => {
                const newItem = { ...item }; // Create a copy of the item
                newItem.date = currentDate; // Update the date to the current week date
                newItem.id = generateUUID(); // Generate a new unique ID for the item
                newGroupedItems.push(newItem); // Add the new item to the array

            });
            currentWeekGroupedItems[currentDate] = newGroupedItems || []; // Map items from previous week to current week
        });

        return currentWeekGroupedItems;
    };

    const fetchResources = async () => {
        FetchEmployeesService(props.token, selectedLocation).then((response) => {
            if (response) {
                const modifiedResponse = [...response, { id: '999999', firstName: 'Open', lastName: 'Shift' }]

                setResources(modifiedResponse);
            }

        });
    };



    useEffect(() => {

        fetchResources();
    }, [selectedLocation]);



    const handleDayPress = (day) => {
        setSelectedDate(day.dateString);
        scrollToDay('animated', day);
    };

    const formatDateLabel = (dateStr) => {
        const date = new Date(dateStr);
        const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${weekday} ${dd}-${mm}-${yyyy}`;
    };

    const formatDateLabelWithoutWeekDay = (dateStr) => {
        const date = new Date(dateStr);
        const weekday = date.toLocaleDateString('en-GB', { weekday: 'long' });
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${dd}-${mm}-${yyyy}`;
    };
    function parseDateFromDDMMYYYY(dateStr) {
        const [day, month, year] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day); // Note: month is 0-based in JS
    }
    const constructTime = (dateStr, timeStr) => {

        // Split the date string into day, month, and year
        const [year, month, day] = dateStr.split('-');

        // Parse the time string using a Date object
        const time = new Date(`1970-01-01T${timeStr}`);

        // Extract hours and minutes from the parsed time
        const hours = time.getHours();
        const minutes = time.getMinutes();

        // Construct the final Date object
        return new Date(year, month - 1, day, hours, minutes);

    }
    const isUserManager = () => {
        return props.additionalUserInfo.role === 'ROLE_CMANAGER' || props.additionalUserInfo.role === 'ROLE_MANAGER';
    }
    const convertDateStringWithCurrentTime = (dateString) => {
        const [year, month, day] = dateString.split('-'); // Split the string into year, month, and day
        const currentTime = new Date(); // Get the current date and time

        // Set the time of the current date object to match the current time (hours, minutes, seconds, milliseconds)
        const resultDate = new Date(year, month - 1, day, currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds(), currentTime.getMilliseconds());

        return resultDate;
    };

    const convertAuDateStringWithCurrentTime = (dateString, timeStr) => {
        const [day, month, year] = dateString.split('-'); // Split the string into year, month, and day
        // Parse the time string using a Date object
        const time = new Date(`1970-01-01T${timeStr}`);

        // Extract hours and minutes from the parsed time
        const hours = time.getHours();
        const minutes = time.getMinutes();

        // Construct the final Date object
        return new Date(year, month - 1, day, hours, minutes);
    };
    const handleCellPress = (day, resource, item) => {
        const bookedItem = item ?? null;
        const modDay = formatDateLabelWithoutWeekDay(day);

        if (bookedItem) {
            setSelectedBookedItem(bookedItem);
            setStarttime(constructTime(day, bookedItem.starttime));
            setEndtime(constructTime(day, bookedItem.endtime));
        } else {
            setSelectedBookedItem(null);
            setStarttime(convertDateStringWithCurrentTime(day));
            setEndtime(convertDateStringWithCurrentTime(day));
        }

        setSelectedCell({ day, resource });
        setIsStartTime(true);
        setShowTimePicker(true);
    }
    const handleCellPressMy = useCallback((day, resource, item) => {
        const bookedItem = item ?? null;

        if (bookedItem) {
            setSelectedBookedItem(bookedItem);
            setStarttime(constructTime(day, bookedItem.starttime));
            setEndtime(constructTime(day, bookedItem.endtime));
        } else {
            setSelectedBookedItem(null);
            setStarttime(convertDateStringWithCurrentTime(day));
            setEndtime(convertDateStringWithCurrentTime(day));
        }

        setSelectedCell({ day, resource });
        setShowIndiviualShiftManagerWindow(true);
    }, [setSelectedBookedItem, setSelectedCell, setStarttime, setEndtime, setShowIndiviualShiftManagerWindow]);
    const formatTimeOnly = (selectedDate) => {
        const hours = String(selectedDate.getHours()).padStart(2, '0');
        const minutes = String(selectedDate.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    };



    const cellPressOpenItemsSetup = (day, resource) => {
        const modDay = formatDateLabelWithoutWeekDay(day);
        const openItemA = bookedItems.find(
            (item) => item.date === modDay && (item.status === 'available' )
        );
        setOpenItem(openItemA);

        if (openItemA) {
            console.log('openItem', openItemA);
            setStarttime(constructTime(day, openItemA.starttime)); // Set start time to current time
            setEndtime(constructTime(day, openItemA.endtime)); // Set end time to the same as start time initially
            setSelectedCell({ day, resource });
            setSelectedBookedItem(openItemA); // Reset selected booked item
            setSelectedOpenItem(openItemA);

        }
        return openItemA;
    }
    const handleCallPressOpenItemsMy = (day, resource) => {

        const openItem = cellPressOpenItemsSetup(day, resource);
        if (openItem) setShowOpenItemModal(true);
    };

    const handleCellPressOpenItemsManager = (day, resource) => {
        const openItem = bookedItems.find(
            (item) => item.date === formatDateLabelWithoutWeekDay(day) && (item.status === 'available')
        );

        if (!openItem) {
            return;
        }

        console.log('openItem', openItem);
        setStarttime(constructTime(day, openItem.starttime));
        setEndtime(constructTime(day, openItem.endtime));
        setSelectedCell({ day, resource });
        setSelectedBookedItem(openItem);
        setSelectedOpenItem(openItem);

        cellPressOpenItemsSetup(day, resource);
        setShowOpenItemModalManager(true);

    };



    const onAssignOpenItem = (selectedBookedItem, resource) => {
        //console.log('selcell',resource);

        if (selectedBookedItem) {
            const startValue = starttime instanceof Date ? formatTimeOnly(starttime) : starttime;
            const endValue = endtime instanceof Date ? formatTimeOnly(endtime) : endtime;
            const updatedItem = {
                ...selectedBookedItem,
                staffId: resource.id,
                status: '',
                starttime: startValue || selectedBookedItem.starttime,
                endtime: endValue || selectedBookedItem.endtime,
            };

            AddBookedItemRoster([updatedItem], props.token).then(response => {

                setBookedItems((prevState) => {
                    const updatedItems = prevState.map((item) =>
                        item.id === selectedBookedItem.id ? updatedItem : item
                    );
                    return updatedItems;
                });
                //setBookedItemsVersion(v => v + 1);
                setSelectedOpenItem(updatedItem);
            });
            setShowOpenItemModalManager(false);
            console.log('updatedItem', updatedItem);
        }
    }

    const claimOpenItem = () => {
        if (!selectedOpenItem || !currentUserId) {
            return;
        }

        const updatedItem = {
            ...selectedOpenItem,
            staffId: currentUserId,
            status: '',
            openForAll: 'no',
        };

        AddBookedItemRoster([updatedItem], props.token).then(() => {
            setBookedItems((prevState) => prevState.map((item) => (
                item.id === selectedOpenItem.id ? updatedItem : item
            )));
            setSelectedBookedItem(updatedItem);
            setSelectedOpenItem(updatedItem);
            setShowOpenItemModal(false);
            setBookedItemsVersion((value) => value + 1);
        });
    };

    const openShiftFromBookedItem = (bookedItem, reason = "Can't work") => {
        const canClaimWithoutApproval = selectedCompany?.claimOpenShiftWithoutManagerApprovalEnabled === 'Y';
        const updatedItem = {
            ...bookedItem,
            staffId: '',
            reason,
            status: 'available',
            openForAll: canClaimWithoutApproval ? 'yes' : 'no',
        };

        return AddBookedItemRoster([updatedItem], props.token).then(() => {
            setBookedItems((prevState) => prevState.map((item) => (
                item.id === bookedItem.id ? updatedItem : item
            )));
            setSelectedBookedItem(updatedItem);
            setSelectedOpenItem(updatedItem);
            setBookedItemsVersion((value) => value + 1);
            return updatedItem;
        });
    };

    const cantWork = () => {
        if (!selectedBookedItem) {
            return;
        }

        openShiftFromBookedItem(selectedBookedItem).then(() => {
            setShowIndiviualShiftManagerWindow(false);
        });
    };

    const saveBreaks = (updatedBookedItem) => {
        AddBreaksForBookedItem([updatedBookedItem], props.token).then(() => {
            setBookedItems((prevState) => prevState.map((item) => (
                item.id === updatedBookedItem.id ? updatedBookedItem : item
            )));
            setSelectedBookedItem(updatedBookedItem);
        });
    };

    const saveAllowances = (updatedBookedItem) => {
        AddAllowancesForBookedItem([updatedBookedItem], props.token).then(() => {
            setBookedItems((prevState) => prevState.map((item) => (
                item.id === updatedBookedItem.id ? updatedBookedItem : item
            )));
            setSelectedBookedItem(updatedBookedItem);
        });
    };

    const saveUnavailability = (payload) => {
        if (!selectedBookedItem) {
            return;
        }

        AddUnavailability(payload, props.token)
            .then(() => openShiftFromBookedItem(selectedBookedItem, payload.reason || "Can't work"))
            .then(() => {
                setShowUnavailabilityModal(false);
                setShowIndiviualShiftManagerWindow(false);
            });
    };

    //calculating unavailability items
    // Utility to parse "dd-mm-yyyy" to Date
    const parseDate = (dateStr) => {
        const [day, month, year] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    // Generate list of dates between start and end, filtered by weekday if provided
    const generateDateRange = (start, end, weekday = null) => {
        const dates = [];
        let current = start;
        // console.log(start);
        //console.log('end', end);
        while (start <= end) {
            // if (!weekday || current.toLocaleDateString('en-US', { weekday: 'long' }) === weekday) {
            dates.push(new Date(current));
            //}
            current.setDate(current.getDate() + 1);
        }
        return dates;
    };

    // Expand unavailability to individual date entries with start/end times
    const expandUnavailabilityItems = (unavailabilityItems) => {
        const expanded = [];
        if (unavailabilityItems.length === 0) return expanded; // Return empty array if no unavailability items
        for (const item of unavailabilityItems) {
            const start = parseDate(item.startDate);
            const end = parseDate(item.endDate);
            const weekday = item.repeat ? item.repeatSettings.on : null;

            const days = generateDateRange(start, end, weekday);
            //console.log('dDDDays',days);
            for (const day of days) {
                expanded.push({
                    date: formatDateLabelWithoutWeekDay(day), // format: dd/mm/yyyy
                    starttime: item.allDay ? '00:00' : item.startTime || '00:00',
                    endtime: item.allDay ? '23:59' : item.endTime || '23:59',
                });
            }
        }
        //console.log('expanded', expanded);
        return expanded;
    };

    // Compare a booked item with expanded unavailability list
    const checkConflictWithUnavailability = (bookedItem, unavailabilityList) => {
        const bookedDate = formatDateToISO(bookedItem.date) // Format: dd/MM/yyyy
        const bookedStart = new Date(`${bookedDate} ${bookedItem.starttime}`);
        const bookedEnd = new Date(`${bookedDate} ${bookedItem.endtime}`);

        for (const ua of unavailabilityList) {
            const uadate = formatDateToISO(ua.date)
            if (uadate === bookedDate) {

                const uaStart = new Date(`${uadate} ${ua.starttime}`);
                const uaEnd = new Date(`${uadate} ${ua.endtime}`);


                if (bookedStart < uaEnd && bookedEnd > uaStart) {
                    return 'error'; // overlap detected
                }
            }
        }

        return 'success';
    };


    const updateBookedItems = async (selectedStartDate, field, area, selectedEndDate) => {

        const id = selectedCell.resource.id;

        const x = await FetchUnavailabilities(props.token, id).then((response) => {

            const r = response ? response : [];
            return r;
        });

        setBookedItems(prevState => {
            const updatedItems = [...prevState]; // Create a copy of the previous state
            const index = updatedItems.findIndex(item => item.id === selectedBookedItem?.id); // Find the index of the booked item
            if (index !== -1) {
                //console.log('index', index);
                updatedItems[index] = {
                    ...updatedItems[index],
                    starttime: selectedStartDate ? formatTimeOnly(selectedStartDate) : '', // Update the starttime property
                    endtime: selectedEndDate ? formatTimeOnly(selectedEndDate) : '', // Update the endtime property
                    areaName: area ? area : ''
                };
                // Fetch unavailability for the selected resource
                const expanded = expandUnavailabilityItems(x);
                const result = checkConflictWithUnavailability(updatedItems[index], expanded);
                if (result === 'error') {

                    return prevState; // Return the previous state without changes
                } else {
                    setSelectedBookedItem(updatedItems[index]); // Set the selected booked item to the updated one

                    AddBookedItemRoster([updatedItems[index]], props.token);
                }

            } else {
                console.log('index', 'new');
                const newId = generateUUID(); // Generate a unique ID for the new booked item
                const newBookedItem = {
                    id: newId, // Generate a unique ID for the new booked item
                    date: formatDateLabelWithoutWeekDay(selectedStartDate),
                    staffId: selectedCell.resource.id,
                    starttime: selectedStartDate ? formatTimeOnly(selectedStartDate) : '',
                    endtime: selectedEndDate ? formatTimeOnly(selectedEndDate) : '',
                    companyId: props.additionalUserInfo.companyId,
                    locationId: selectedLocation ? selectedLocation.id : '',
                    areaName: area ? area : ''
                }
                const expanded = expandUnavailabilityItems(x);
                const result = checkConflictWithUnavailability(newBookedItem, expanded);
                if (result === 'error') {

                    return prevState; // Return the previous state without changes
                } else {
                    //console.log('new booked item', newBookedItem);
                    updatedItems.push(newBookedItem);
                    setSelectedBookedItem(newBookedItem); // Set the selected booked item to the new one
                    AddBookedItemRoster([newBookedItem], props.token);
                }

            }

            return updatedItems; // Return the updated state
        });
        setBookedItemsVersion(v => v + 1);
    };

    const handleTimeChange = (event, selectedStartDate, type, area = '', selectedEndDate) => {
        //console.log('area',area);
        //if (selectedDate) {
        //if (type==='starttime') {
        //console.log('being called');
        setStarttime(selectedStartDate);
        updateBookedItems(selectedStartDate, 'starttime', area, selectedEndDate); // Update booked items with the new start time

        //setIsStartTime(false); // After start time is selected, switch to end time
        //} else {
        //console.log('console');
        setEndtime(selectedEndDate);
        //updateBookedItems(selectedEndDate, 'endtime',area);
        // setShowTimePicker(false); // Close the time picker after selecting end time

        // Once both start and end times are selected, call saveSchedule
        //saveSchedule(); // Save the schedule when both times are selected
        //}
        //}

    };

    const handleTimeChangeWithField = (event, selectedDate, field) => {

        if (selectedDate) {
            if (field === 'starttime') {
                setStarttime(selectedDate);
                updateBookedItems(selectedDate, 'starttime'); // Update booked items with the new start time


            } else if (field === 'endtime') {
                setEndtime(selectedDate);
                updateBookedItems(selectedDate, 'endtime');


                // Once both start and end times are selected, call saveSchedule
                //  saveSchedule(); // Save the schedule when both times are selected
            }
        }
    };

    const handleTimePickerOpen = (isStart) => {
        setIsStartTime(isStart);
        setShowTimePicker(true);
    };

    const formatTime = (time) => {
        return time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    const isCellEmpty = (day, resource) => {
        // Dummy check for empty data (You can use a specific condition or data)
        // For simplicity, let's make a few cells empty
        // In a real scenario, you would check against your data source
        const modDay = formatDateLabelWithoutWeekDay(day);
        if (bookedItems.length > 0) {
            const bookedItemsForDay = bookedItems?.some((item) => item.date === modDay && ((item.staffId === resource.id) || (item.status && item.status === 'available')));

            if (!bookedItemsForDay) {
                return true;
            }
        } else {

            return true;
        }
    };


    const determineCellStatus = (day, resource) => {

        const modDay = formatDateLabelWithoutWeekDay(day);

        if (bookedItems.length > 0) {
            const bookedItemsForDay = bookedItems.some((item) => item.date === modDay && item.staffId === resource.id);
            //console.log(bookedItemsForDay)
            if (bookedItemsForDay) {

                const bookedItem = bookedItems?.find((item) => item.date === modDay && item.staffId === resource.id);
                if (bookedItem.status === 'sstarted') {
                    return 'sstarted'; // Green color for started status
                } else if (bookedItem.status === 'timesheet') {
                    return 'timesheet'; // Red color for timesheet status 
                } else if (bookedItem.status === '') {
                    return ''; // Orange color for empty status
                }
            }
        }
        return '';

    }

    const copyPreviousWeek = () => {

        const previousWeekGroupedItems = getPreviousWeekBookedItems(bookedItems);

        const mappedItems = mapPreviousWeekToCurrentWeek(previousWeekGroupedItems);

        const newBookedItems = extractBookedItemsFromMappedItems(mappedItems);

        if (newBookedItems.length > 0) {
            AddBookedItemListRoster(newBookedItems, props.token).then((response) => {
                if (response) {

                    setBookedItems((prevState) => {
                        const updatedItems = [...prevState]; // Create a copy of the previous state
                        Object.values(mappedItems).forEach((items) => {
                            items.forEach((item) => {
                                updatedItems.push(item); // Add the item to the updated items array
                            });
                        });
                        return updatedItems; // Return the updated state
                    }
                    );
                    setBookedItemsVersion(v => v + 1);
                }
            });
        }
    }

    const deleteCurrentWeekBookedItems = () => {
        // Get today's date
         const currentDayIndex = pageDates[currentWeekIndex][0] ? dates.findIndex(date => date === pageDates[currentWeekIndex][0]) : 0;

        
        const targetDay = new Date(dates[currentDayIndex]);
       
        // Calculate the start of this week (assuming the week starts on Sunday)
        const startOfThisWeek = new Date(targetDay);
        
        // Create an array of the seven days of the current week
        const currentWeekDates = [];
        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfThisWeek);
            day.setDate(startOfThisWeek.getDate() + i);
            currentWeekDates.push(formatDateLabelWithoutWeekDay(day.toISOString().split('T')[0])); // Format as DD-MM-YYYY
        }

        // Find all booked items for the current week
        const currentWeekBookedItems = bookedItems.filter((item) =>
            currentWeekDates.includes(item.date)
        );

        // Call DeleteBookedItem to delete these booked items
        if (currentWeekBookedItems.length > 0) {
            DeleteBookedItemRoster(currentWeekBookedItems, props.token).then((response) => {
                if (response) {


                    // Remove these items from the bookedItems state variable
                    setBookedItems((prevState) =>
                        prevState.filter(
                            (item) => !currentWeekBookedItems.some((toDelete) => toDelete.id === item.id)
                        )
                    );
                    setBookedItemsVersion(v => v + 1);
                }
            });
        }
    };

    function ScheduleCellOther(props) {
        const {
            day,
            resource,
            bookingStatus,
            isEmpty,
            selectedDate,
            isUserManager,
            rosterType,

            availableItems = [],
        } = props;

        const [highlighted, setHighlighted] = React.useState(false);
        const handleCellPress = (day, resource, item) => {
            const bookedItem = item ?? null;
            const modDay = formatDateLabelWithoutWeekDay(day);

            if (bookedItem) {
                setSelectedBookedItem(bookedItem);
                setStarttime(constructTime(day, bookedItem.starttime));
                setEndtime(constructTime(day, bookedItem.endtime));
            } else {
                setSelectedBookedItem(null);
                setStarttime(convertDateStringWithCurrentTime(day));
                setEndtime(convertDateStringWithCurrentTime(day));
            }

            setSelectedCell({ day, resource });
            setIsStartTime(true);
            setShowTimePicker(true);
        }
        const handlePress = (item) => {
            //console.log('handlePress called', { day, resource, item, isUserManager });
            const isOpenItem = item && item.status && item.status === 'available';
            const isOpenResource = resource.firstName === 'Open';

            if (rosterType === 'my') {
                if (isOpenItem || isOpenResource) {
                    handleCallPressOpenItemsMy(day, resource);
                    return;
                }

                if (item && String(resource.id) === String(currentUserId)) {
                    handleCellPressMy(day, resource, item);
                }
                return;
            }
            
            if (typeof isUserManager === 'function' && isUserManager()) {
                if (item && item.status && item.status === 'available') {
                    console.log('Opedddn item clicked');
                    handleCellPressOpenItemsManager(day, resource);
                } 
                else if(resource.firstName!='Open'){
                    console.log('am i here');
                    handleCellPress(day, resource, item);
                }
            }
        };

        return (
            <div
                className={`cell-row ${highlighted ? 'highlighted' : ''}`}
                style={{ width: '100px', flexWrap: 'wrap' }}
            >
                {availableItems.length > 0 ? (
                    <>
                    {availableItems.map((item, index) => (
                        <>
                        <div
                            key={`${item.id}-${index}`}
                            className={`cell ${selectedDate === day ? 'selected' : ''} ${bookingStatus === 'sstarted'
                                ? 'in-progress'
                                : bookingStatus === 'timesheet'
                                    ? 'end-shift'
                                    : ''
                                }`}
                            style={{
                                width: `${100 / availableItems.length}%`,
                                height: `45px`,
                                cursor: 'pointer',


                            }}
                            onClick={() => handlePress(item)}
                        >
                            <span className="cell-text">
                                {isEmpty(day, resource)
                                    ? isUserManager()
                                        ? <ScheduleCellContentWithScheduleText openItem={resource && resource.firstName==='Open'}/>
                                        : <ScheduleCellContentEmpty />
                                    : <CellRenderer day={day} item={item} resource={resource} />}
                            </span>
                        </div>
                        
                        </>
                    ))}
                    <div
                        className={`cell
                            }`}
                        style={{
                            width: '100px',
                            height: 45,
                            display: 'flex',

                            padding: '4px',
                            boxSizing: 'border-box',
                        }}
                        onClick={() => handlePress(null)}
                    >
                        <span className="cell-text">
                        { isUserManager()
                                        ? <ScheduleCellContentWithScheduleText/>
                                        : null}
                        </span>
                      </div>
                    
                   </>
                    
                ) : (
                    <div
                        className={`cell ${selectedDate === day ? 'selected' : ''} ${bookingStatus === 'sstarted'
                            ? 'in-progress'
                            : bookingStatus === 'timesheet'
                                ? 'end-shift'
                                : ''
                            }`}
                        style={{
                            width: '100px',
                            height: 45,
                            display: 'flex',

                            padding: '4px',
                            boxSizing: 'border-box',
                        }}
                        onClick={() => handlePress(null)}
                    >
                        <span className="cell-text">
                            {isEmpty(day, resource)
                                ? isUserManager()
                                    ? <ScheduleCellContentWithScheduleText openItem={resource && resource.firstName==='Open'}/>
                                    : <ScheduleCellContentEmpty />
                                : <CellRenderer day={day} resource={resource} />}
                        </span>
                    </div>
                )}
                
            </div>
        );
    }


    const ScheduleCellMy = React.memo(
        ({
            day,
            resource,
            bookingStatus,
            isEmpty,
            selectedDate,
            handleCellPressMy,
            availableItems = [],
            cellHeight = 60, // default if not passed
        }) => {
            const handlePress = (item) => {
                const newItem = { ...item } ?? null;
                handleCellPressMy(day, resource, newItem);
            };

            return (
                <div className="cell-row" style={{ flexWrap: 'wrap', width: 100 }}>
                    {availableItems.length > 0 ? (
                        availableItems.map((item, index) => (
                            <div
                                key={`${item.id}-${index}`}
                                className={`cell 
                ${selectedDate === day ? 'selected' : ''}
                ${bookingStatus === 'sstarted' ? 'in-progress' : ''}
                ${bookingStatus === 'timesheet' ? 'end-shift' : ''}
              `}
                                style={{
                                    width: `${100 / availableItems.length}%`,
                                    height: `${cellHeight}px`,
                                    cursor: isEmpty ? 'default' : 'pointer',
                                }}
                                onClick={() => !isEmpty && handlePress(item)}
                            >
                                <span className={`cell-text ${bookingStatus === 'sstarted'
                                    ? 'in-progress-text'
                                    : bookingStatus === 'timesheet'
                                        ? 'end-shift-text'
                                        : ''
                                    }`}>
                                    {isEmpty ? (
                                        <ScheduleCellContentEmpty />
                                    ) : (
                                        <CellRenderer day={day} item={item} resource={resource} />
                                    )}
                                </span>
                            </div>
                        ))
                    ) : (
                        <div
                            className={`cell 
              ${selectedDate === day ? 'selected' : ''}
              ${bookingStatus === 'sstarted' ? 'in-progress' : ''}
              ${bookingStatus === 'timesheet' ? 'end-shift' : ''}
            `}
                            style={{ height: `${cellHeight}px` }}
                        >
                            <span className={`cell-text ${bookingStatus === 'sstarted'
                                ? 'in-progress-text'
                                : bookingStatus === 'timesheet'
                                    ? 'end-shift-text'
                                    : ''
                                }`}>
                                {isEmpty ? (
                                    <ScheduleCellContentEmpty />
                                ) : (
                                    <CellRenderer day={day} resource={resource} />
                                )}
                            </span>
                        </div>
                    )}
                </div>
            );
        },
        (prevProps, nextProps) =>
            prevProps.day === nextProps.day &&
            prevProps.resource.id === nextProps.resource.id &&
            prevProps.bookingStatus === nextProps.bookingStatus &&
            prevProps.isEmpty === nextProps.isEmpty &&
            prevProps.selectedDate === nextProps.selectedDate &&
            JSON.stringify(prevProps.availableItems) === JSON.stringify(nextProps.availableItems)
    );




    const ScheduleCellContent = React.memo(
        ({ starttime, endtime, areaName }) => {
            const prev = useRef({ starttime: null, endtime: null, rendered: null });

            const hasChanged =
                prev.current.starttime !== starttime ||
                prev.current.endtime !== endtime;

            if (!hasChanged && prev.current.rendered) {
                return prev.current.rendered;
            }

            const rendered = (
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }}>
                    <span style={{ color: '#333', fontSize: 14, fontWeight: 'bold' }}>
                        {`${starttime} - ${endtime}`}
                    </span>
                    <span style={{ fontSize: 10 }}>
                        {areaName ? areaName.toUpperCase().substring(0, 10) : ''}
                    </span>
                </div>
            );

            prev.current = { starttime, endtime, rendered };
            return rendered;
        },
        (prevProps, nextProps) =>
            String(prevProps.starttime) === String(nextProps.starttime) &&
            String(prevProps.endtime) === String(nextProps.endtime)
    );

    const getBookedItem = (bookedItems, day, staffId) => {
        const modDay = formatDateLabelWithoutWeekDay(day);
        return bookedItems.find(item => item.date === modDay && item.staffId === staffId);
    };


    const CellRenderer = React.memo(
        ({ day, resource, item, bookedItems }) => {


            return (
                <ScheduleCellContent
                    starttime={item?.starttime || ''}
                    endtime={item?.endtime || ''}
                    areaName={item?.areaName}
                />
            );
        },
        (prevProps, nextProps) =>
            prevProps.day === nextProps.day &&
            prevProps.resource.id === nextProps.resource.id &&
            prevProps.bookedItems === nextProps.bookedItems
    );

    const bookedItemsMap = useMemo(() => {
        const map = {};
        for (let item of bookedItems) {
            const key = `${item.staffId}_${item.date}`;
            if (!map[key]) map[key] = [];
            map[key].push(item);
        }
        return map;
    }, [bookedItems]);

    const getAvailableItems = (resource, day) => {
        if (resource.firstName === 'Open') {
            return bookedItems.filter((item) => {
                return item.date === formatDateLabelWithoutWeekDay(day) && ((item.status && item.status === 'available') || !item.staffId);
            });
        }

        return bookedItemsMap[`${resource.id}_${formatDateLabelWithoutWeekDay(day)}`] || [];
    };
    const ScheduleCellContentWithScheduleText = (props) => {
        return props.openItem?<div></div>:<div>+</div>; // fallback if nothing booked
    };

    const ScheduleCellContentEmpty = React.memo(() => {
        return <div></div>; // fallback if nothing booked
    });

    const organiseName = (name) => {
        if (name) {
            return name;
        }
        else {
            return "";
        }

    }

    const generateScheduleContent = (resource, day) => {
        const bookingStatus = determineCellStatus(day, resource);
        const availableItems = getAvailableItems(resource, day);

        return (
            <div>
                <ScheduleCellOther
                    day={day}
                    resource={resource}
                    bookingStatus={bookingStatus}
                    isEmpty={isCellEmpty}         // pass the function to check if empty
                    selectedDate={selectedDate}
                    isUserManager={isUserManager} // pass the function directly here
                    rosterType={props.type}
                    availableItems={availableItems}
                />
            </div>
        );
    };



    // Round time string (HH:mm) to nearest 15 minutes
    const roundTimeToNearest15 = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        const totalMinutes = hours * 60 + minutes;

        // Round to nearest 15 minutes
        const roundedTotalMinutes = Math.round(totalMinutes / 15) * 15;
        const roundedHours = Math.floor(roundedTotalMinutes / 60)
            .toString()
            .padStart(2, '0');
        const roundedMinutes = (roundedTotalMinutes % 60).toString().padStart(2, '0');

        return `${roundedHours}:${roundedMinutes}`;
    };

    const updateShiftStatus = (bookedItem, status, timetype, time) => {
        if (!bookedItem || !bookedItem.starttime || !bookedItem.endtime) {
            console.error('Invalid booked item or missing start/end time.');
            return;
        }

        let updatedItem = {};
        if (timetype === 'start') {
            updatedItem = {
                ...bookedItem,
                starttime: roundTimeToNearest15(time),
                status,
            };
            setStarttime(convertAuDateStringWithCurrentTime(bookedItem.date, time)); // assuming this is a state setter
        } else if (timetype === 'end') {
            updatedItem = {
                ...bookedItem,
                endtime: roundTimeToNearest15(time),
                status,
            };
        }

        setSelectedBookedItem(updatedItem);

        setBookedItems((prevState) =>
            prevState.map((item) => (item.id === bookedItem.id ? updatedItem : item))
        );

        setBookedItemsVersion((v) => v + 1);

        AddBookedItemRoster([updatedItem], props.token)
            .then((response) => {
                console.log('Shift processed successfully:', response);
            })
            .catch((error) => {
                console.error('Error processing end shift:', error);
            });
    };

    const updateAllowances = (bookedItem) => {
        console.log('updateAllowances', bookedItem);
        setBookedItems((prevState) =>
            prevState.map((item) => (item.id === bookedItem.id ? bookedItem : item))
        );
    };

    const renderDateRow = useCallback(
        ({ item: day }) => (
            <div key={day} style={{ display: 'flex', flexDirection: 'row', marginBottom: 4 }}>
                <div
                    style={{
                        height: cellHeight,
                        width: 100,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        border: '1px solid #ccc',
                        padding: '4px',
                        boxSizing: 'border-box',
                    }}
                >
                    <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                        {formatShortDateLabel(day).split(', ')[0]}
                    </span>
                    <span style={{ fontSize: 12, color: '#666' }}>
                        {formatShortDateLabel(day).split(', ')[1]}
                    </span>
                </div>
            </div>
        ),
        [resources, generateScheduleContent, formatDateLabel]
    );

    const scrollToDayAsync = async () => {
        return new Promise((resolve) => {
            scrollToDay(true, null);
            setTimeout(resolve, 2000); // Wait for scrollToDay animation (adjust duration as needed)
        });
    };


    const scrollToDay = (animated, day) => {
        const today = day || new Date().toISOString().split('T')[0];

        const movedWeekIndex = pageDates.findIndex(week =>
            week.some(date => date === today)
        );

        if (movedWeekIndex === -1) return;

        if (listRef.current && movedWeekIndex >= 0) {
            // Calculate the scroll position for the week index
            // Assuming each row has fixed height, e.g. cellHeight * number of rows per week
            const scrollPosition = movedWeekIndex * cellHeight * VERTICAL_CELL_COUNT;

            if (animated) {
                // Smooth scroll for modern browsers
                listRef.current.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth',
                });
                scheduleDateRef.current.scrollTo({
                    top: scrollPosition,
                    behavior: 'smooth',
                });
            } else {
                // Instant scroll
                listRef.current.scrollTop = scrollPosition;
                scheduleDateRef.current.scrollTop = scrollPosition;
            }
        }
    };
    const extractBookedItemsFromMappedItems = (mappedItems) => {
        return Object.values(mappedItems).flat();
    };

    const handleScrollEnd = (event) => {
        const offsetY = event.target.scrollTop; // scrollTop for web scroll containers
        const dayIndex = Math.round(offsetY / cellHeight);

        const dayIndexBeforeScroll = currentWeekIndex * VERTICAL_CELL_COUNT;

        if (previousDayIndexRef.current === null) {
            previousDayIndexRef.current = dayIndex;
        }

        const diff = dayIndex - dayIndexBeforeScroll;

        // If moved fewer than 3 rows, snap back to currentWeekIndex
        if (Math.abs(diff) < 3) {
            const scrollPosition = currentWeekIndex * cellHeight * VERTICAL_CELL_COUNT;

            listRef.current?.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
            });
            scheduleDateRef.current?.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
            });
            return;
        } else {
            const weeksToMove = diff > 0 ? 1 : -1; // one full week forward or back
            const targetDayIndex = dayIndexBeforeScroll + weeksToMove * VERTICAL_CELL_COUNT;

            const targetDate = dates[targetDayIndex];
            if (!targetDate) return;

            const movedWeekIndex = pageDates.findIndex(week =>
                week.some(date => date === targetDate)
            );
            setCurrentWeekIndex(movedWeekIndex);

            if (movedWeekIndex === -1) return;

            const scrollPosition = movedWeekIndex * cellHeight * VERTICAL_CELL_COUNT;

            listRef.current?.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
            });
            scheduleDateRef.current?.scrollTo({
                top: scrollPosition,
                behavior: 'smooth',
            });

            previousDayIndexRef.current = targetDayIndex;
        }
    };


    // renderDay equivalent
    const RenderDay = ({ day, resources, pageDates, cellHeight, generateScheduleContent, bookedItemsVersion, bookedItemsMap }) => {
        return (
            <div key={day} style={styles.rowBlock}>
                <div key={day} style={{ display: 'flex', flexDirection: 'row', marginBottom: 4 }}>
                    <div
                        style={{
                            height: '45px',
                            width: 100,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            border: '1px solid #ccc',

                            boxSizing: 'border-box',
                        }}
                    >
                        <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                            {formatShortDateLabel(day).split(', ')[0]}
                        </span>
                        <span style={{ fontSize: 12, color: '#666' }}>
                            {formatShortDateLabel(day).split(', ')[1]}
                        </span>
                    </div>
                </div>
                {resources.length > 0 && pageDates.length > 0 && (
                    <>
                        {resources.map((item) => (
                            <div
                                key={`${day}-${item.id}`}

                            >
                                {generateScheduleContent(item, day)}
                            </div>
                        ))}

                    </>
                )}

            </div>
        );
    };

    const removeBookedItem = () => {
        if (!selectedBookedItem) return;

        const itemId = selectedBookedItem.id;

        DeleteBookedItemRoster([selectedBookedItem], props.token).then(response => {
            if (response) {
                // Only update state after deletion succeeds
                setBookedItems(prevState => {
                    const updatedItems = prevState.filter(item => item.id !== itemId);
                    return updatedItems;
                });
                setSelectedBookedItem(null);
                setBookedItemsVersion(v => v + 1);
            } else {

            }
        });
    };
    // renderWeek equivalent
    const renderWeek = (week) => {
        return (
            <div >
                {week.map((day) => (
                    <RenderDay
                        key={day}
                        day={day}
                        resources={resources}
                        pageDates={pageDates}
                        cellHeight={cellHeight}
                        generateScheduleContent={generateScheduleContent}

                        bookedItemsVersion={bookedItemsVersion}
                        bookedItemsMap={bookedItemsMap}
                    />
                ))}
            </div>
        );
    };

    // renderWeekWithDates equivalent
    const renderWeekWithDates = (week) => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', overflowX: 'auto' }}>
                <div
                    style={{

                    }}
                ></div>
                {week.map((day) => (
                    <div key={day}>
                        {renderDateRow({ item: day })}
                    </div>
                ))}
            </div>
        );
    };

    const generateResourceContent = (resource) => {
        const firstLetter = organiseName(resource?.firstName).substring(0, 1) +
            organiseName(resource?.lastName).substring(0, 1);
        const initials =
            organiseName(resource?.firstName).substring(0, 5) +
            " " +
            organiseName(resource?.lastName).substring(0, 3) +
            (resource.lastName ? "." : "");

        const isMyType = props.type === 'my';
        const isCurrentUser = resource.id === props.additionalUserInfo.id;
    const isOpenShiftResource = resource.firstName === 'Open';

        const isManager =
            props.additionalUserInfo.role === 'ROLE_CMANAGER' ||
            props.additionalUserInfo.role === 'ROLE_MANAGER';

        const isFWorkerWithDefault =
            props.additionalUserInfo.role === 'ROLE_FWORKER' &&
            selectedLocation.defaultLocation === 'Y';

        const canPress = isManager || isFWorkerWithDefault;

        return (
            <div key={resource.id} style={{ display: 'inline-block', margin: '0 10px 8px 0px' }}>
                {isMyType ? (
                    isCurrentUser || isOpenShiftResource ? (
                        <button

                            onClick={() => console.log('M')}
                            style={{ ...styles.profileIcon, marginLeft: 25 }}
                        >
                            <span style={styles.profileInitials}>{isOpenShiftResource ? 'Open Shift' : initials}</span>
                        </button>
                    ) : (
                        <span></span>
                    )
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                        <div
                            onClick={() => console.log('M')}
                            style={{
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#007bff',
                                color: '#fff',
                                borderRadius: '50%',
                                width: 40,
                                height: 40,
                                // marginLeft: 5,
                                fontWeight: 'bold',
                                fontSize: 16,
                                userSelect: 'none',
                                padding: 5,
                                //...styles.profileIcon,
                            }}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    console.log('M');
                                }
                            }}
                        >
                            <span style={styles.profileInitials}>{firstLetter}</span>
                        </div>
                        <div style={{ marginLeft: 6 }}>{initials}</div>
                    </div>

                )}
            </div>
        );
    };

    const styles = {
        container: { position: 'relative', padding: 20 },
        loadingOverlay: {
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 10,
        },
        floatedGoToToday: {
            position: 'fixed',
            bottom: 20,
            right: 20,
            padding: '10px 20px',
            backgroundColor: '#4287f5',
            color: 'white',
            border: 'none',
            borderRadius: 5,
            cursor: 'pointer',
            zIndex: 20,
        },
        toggleIcon: { fontWeight: 'bold' },
        headerRow: { display: 'flex', flexDirection: 'row' },
        secondaryDateContainer: {},
        secondaryContainer: { flex: 1 },
        profileIcon: { padding: 10, cursor: 'pointer' },
        profileIcon2: { padding: 10, cursor: 'pointer' },
        headerCell: { padding: 5 },
        profileInitials: { fontWeight: 'bold', width: '100px' },
        calendar: { marginBottom: 20 },
        rowBlock: {
            display: 'flex',
            flexDirection: 'row',
            borderBottom: '1px solid #ccc',
            padding: 5,
        },
        dataRow: {
            display: 'flex',
            flexDirection: 'row',
            overflowX: 'auto', // horizontal scroll for resources
        },
    };
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            render: (text, record) => {
                //console.log('rendering date cell', record);
                return (
                    <div style={{ width: 100, height: 45, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <span style={{ fontWeight: 'bold', fontSize: 14 }}>
                            {formatShortDateLabel(record.date).split(', ')[0]}
                        </span>
                        <span style={{ fontSize: 12, color: '#666' }}>
                            {formatShortDateLabel(record.date).split(', ')[1]}
                        </span>
                    </div>
                );
            }
        },
        ...displayedResources.map((resource) => {
            return {
                title: generateResourceContent(resource),
                dataIndex: resource.id,
                key: resource.id,
                render: (text, record) => {
                    const day = record.date;
                    const bookingStatus = determineCellStatus(day, resource);

                    return (
                        <ScheduleCellOther
                            day={day}
                            resource={resource}
                            bookingStatus={bookingStatus}
                            isEmpty={(day, resource) => isCellEmpty(day, resource)}
                            selectedDate={selectedDate}
                            rosterType={props.type}

                            availableItems={record[resource.id]}
                            isUserManager={isUserManager}
                        />
                    );
                }

            };
        }),

    ];
    return (
        <div style={styles.container}>
            {loading && (
                <div style={styles.loadingOverlay}>
                    <div className="spinner" />
                    <span style={{ color: '#333', marginTop: 10 }}>Loading...</span>
                </div>
            )}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px' }}>
                <Button onClick={goToPrevWeek} disabled={isExtending || currentWeekIndex === 0}>
                    Previous Week
                </Button>
                <Button onClick={() => setShowModal(true)} disabled={isExtending || currentWeekIndex === 0}>
                    Change location
                </Button>
                {isUserManager() && props.type !== 'my' ? <Button onClick={copyPreviousWeek} disabled={isExtending || currentWeekIndex === 0}>
                    Copy previous Week
                </Button> : null}
                {isUserManager() && props.type !== 'my' ? <Button onClick={deleteCurrentWeekBookedItems} disabled={isExtending || currentWeekIndex === 0}>
                    Clear this Week
                </Button> : null}
                {isUserManager() && props.type !== 'my' ? <Button onClick={() => setShowTemplateModal(true)}>
                    Templates
                </Button> : null}
                <Button
                    onClick={goToNextWeek}
                    disabled={isExtending}
                >
                    Next Week
                </Button>
            </div>
            {/* Horizontally scrollable table container */}
            <div style={{ width: '100%', overflowX: 'auto' }}>
                <Table
                    dataSource={combinedList}
                    columns={columns}
                    pagination={false}
                    scroll={{ x: 'max-content' }}
                />
            </div>
            {/* Modals and dialogs ...existing code... */}
            {showTimePicker && (
                <TimePicker
                    token={props.token}
                    removeBookedItem={removeBookedItem}
                    handleTimeChange={handleTimeChange}
                    starttime={starttime}
                    endtime={endtime}
                    setShowTimePicker={setShowTimePicker}
                    selectedBookedItem={selectedBookedItem}
                    isStartTime={isStartTime}
                    setStarttime={setStarttime}
                    setEndtime={setEndtime}
                />
            )}
            <ManagerOpenItemDialog
                showOpenItemModalManager={showOpenItemModalManager}
                onAssignOpenItem={onAssignOpenItem} handleTimeChange={handleTimeChange}
                setShowOpenItemModalManager={setShowOpenItemModalManager}
                selectedBookedItem={openItem} setSelectedBookedItem={setSelectedBookedItem} setStarttime={setStarttime} setEndtime={setEndtime} resources={resources}
                starttime={starttime}
                endtime={endtime}
                selectedLocation={selectedLocation}
                token={props.token}
                removeBookedItem={removeBookedItem}
            />
            <OpenShiftClaimDialog
                open={showOpenItemModal}
                selectedBookedItem={selectedOpenItem}
                starttime={selectedOpenItem?.starttime}
                endtime={selectedOpenItem?.endtime}
                onClaim={claimOpenItem}
                onCancel={() => setShowOpenItemModal(false)}
            />
            <ShiftActionModal
                open={showIndiviualShiftManagerWindow}
                selectedBookedItem={selectedBookedItem}
                onClose={() => setShowIndiviualShiftManagerWindow(false)}
                onStartShift={() => updateShiftStatus(selectedBookedItem, 'sstarted', 'start', formatTimeOnly(new Date()))}
                onEndShift={() => updateShiftStatus(selectedBookedItem, 'timesheet', 'end', formatTimeOnly(new Date()))}
                onOpenCantWork={() => setShowUnavailabilityModal(true)}
                onRemove={() => {
                    removeBookedItem();
                    setShowIndiviualShiftManagerWindow(false);
                }}
                onSaveBreaks={saveBreaks}
                onSaveAllowances={saveAllowances}
            />
            <UnavailabilityModal
                open={showUnavailabilityModal}
                onClose={() => setShowUnavailabilityModal(false)}
                onSave={saveUnavailability}
                selectedBookedItem={selectedBookedItem}
                staffId={currentUserId}
            />
            <RosterTemplateModal
                open={showTemplateModal}
                onClose={() => setShowTemplateModal(false)}
                token={props.token}
                companyId={selectedLocation?.companyId || props.additionalUserInfo?.companyId}
                locationId={selectedLocation?.id}
                bookedItems={bookedItems.filter((item) => item.locationId === selectedLocation?.id)}
                currentWeekRange={currentWeekRange}
                onApplied={(generatedItems) => {
                    setBookedItems((prevState) => [...prevState, ...generatedItems]);
                    setBookedItemsVersion((value) => value + 1);
                    setShowTemplateModal(false);
                }}
            />
        </div>
    )
}


function RosterMainScreen(props) {
    const [selectedLocation, setSelectedLocation] = React.useState({});
    const [companyAndLocations, setcompanyAndLocations] = useState([]);
    const [bookedItems, setBookedItems] = useState([]);
    const token = props.token;
    const [showModal, setShowModal] = useState(false); // Show by default

    useEffect(() => {
        FetchRosterAllocationService(token).then((response) => {
                       if (response) {
                          // console.log('booked items from Roster main', response);
                           setBookedItems(response);
                       }
                   });
    }, []);
    const isUserManager = () => {
        return props.additionalUserInfo.role === 'ROLE_CMANAGER' || props.additionalUserInfo.role === 'ROLE_MANAGER';
    }

    const tabItems = [
        {
            key: 'mine',
            label: 'Mine',
            children: <Roster selectedLocation={selectedLocation} type="my" bookedItems={bookedItems} setBookedItems={setBookedItems} companyAndLocations={companyAndLocations} {...props} showModal={showModal} setShowModal={setShowModal} />,
        },
        ...([{
            key: 'schedule',
            label: 'Schedule',
            children: <Roster selectedLocation={selectedLocation} type="schedule" bookedItems={bookedItems} setBookedItems={setBookedItems} companyAndLocations={companyAndLocations} {...props} showModal={showModal} setShowModal={setShowModal} />,
        }]),
    ];



    return (
        <div>
            <Tabs items={tabItems} destroyInactiveTabPane />
           
            <Location token={props.token} showModal={showModal} setShowModal={setShowModal} companyAndLocations={companyAndLocations} setcompanyAndLocations={setcompanyAndLocations} selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation} setBookedItems={setBookedItems} bookedItems={bookedItems} />



        </div>


    );
}

export { Roster, RosterMainScreen };